import {useQuery, gql} from '@apollo/client';
import {GetAllPadAdvisers} from '../schema-types/GetAllPadAdvisers';
import {ADVISER_DETAILS} from '../graphql/fragments';

export const GET_ALL_PAD_ADVISERS = gql`
  query GetAllPadAdvisers {
    allPadAdvisers {
      ...AdviserDetails
    }
  }
  ${ADVISER_DETAILS}
`;

export const useAllPadAdvisers = () => {
  const {data, loading, error} = useQuery<GetAllPadAdvisers>(GET_ALL_PAD_ADVISERS);

  const allPadAdvisers = data?.allPadAdvisers || [];

  return {
    allPadAdvisers,
    loading,
    error,
  };
};
